/* eslint-disable */
import store from "@/store";
const directorAuth = (to, from, next) => {
  if (!store.getters.isDirectorAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/director/loginDo");
  } else {
    next();
  }
};
const funeralAuth = (to, from, next) => {
  if (!store.getters.isFuneralAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/funeral/loginDo");
  } else {
    next();
  }
};

export default [
  {
    meta: {
      title: "Obituary"
    },
    path: "/director/obituaryReg",
    name: "ObituaryReg",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/obituary/ObituaryReg.vue")
  },
  {
    meta: {
      title: "ObituaryUpdate"
    },
    path: "/director/obituaryUpdate",
    name: "ObituaryUpdate",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/obituary/ObituaryUpdate.vue")
  },
  {
    meta: {
      title: "Obituary2"
    },
    path: "/director/obituaryReg2",
    name: "ObituaryReg2",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/obituary/ObituaryReg2.vue")
  },
  {
    meta: {
      title: "Obituary"
    },
    path: "/funeral/obituaryReg",
    name: "ObituaryReg",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/obituary/ObituaryReg.vue")
  },
  {
    meta: {
      title: "ObituaryUpdate"
    },
    path: "/funeral/obituaryUpdate",
    name: "ObituaryUpdate",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/obituary/ObituaryUpdate.vue")
  },
  {
    meta: {
      title: "Obituary2"
    },
    path: "/funeral/obituaryReg2",
    name: "ObituaryReg2",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/obituary/ObituaryReg2.vue")
  },
  {
    meta: {
      title: "Obituary"
    },
    path: "/director/obituaryRegEx",
    name: "ObituaryRegEx",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/obituary/ObituaryRegEx.vue")
  },
  {
    meta: {
      title: "ObituaryRegEx"
    },
    path: "/funeral/obituaryRegEx",
    name: "ObituaryRegEx",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/obituary/ObituaryRegEx.vue")
  },
];
